// import Vue from "vue";
import { getBeneficiaries } from "@/shared/api/bankService";
import { defineStore } from "pinia";
import { handleError } from "@/shared/storeHelper";
import { BeneficiaryState, FetchState, Beneficiary } from "@/shared/types";
import _ from "lodash";


export const initialState: BeneficiaryState = {
    beneficiaries: [],
    fetchState: FetchState.Uninitialized,
    username: ""
};

export const useBeneficiaryStore = defineStore("beneficiary", {
    state: (): BeneficiaryState => (_.cloneDeep(initialState)),
    getters: {
        isBeneficiariesLoaded: state => state.fetchState === FetchState.Loaded,
        isLoading: state => state.fetchState === FetchState.Loading,
        isFailed: state => state.fetchState === FetchState.Failed
    },
    actions: {
        loadBeneficiaries  (args?: { username: string, partnerId: number} ) {
            if (this.username === args.username) {
                return;
              }

            this.fetchState = FetchState.Loading;

            return getBeneficiaries(args)
            .then(response => {
                this.beneficiaries = response.data.beneficiaries.reduce((accumulator, current) => {
                    accumulator[current.id] = current;
                    return accumulator;
                }, {});
                this.username = args.username;
                this.fetchState = FetchState.Loaded;
            })
            .catch(err => {
                this.fetchState = FetchState.Failed;
                handleError({error: err, rethrow: false });
            });
        }
    }
});